import { Outlet } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";
import { observer } from "mobx-react-lite";
import AdminPanelSidebar from "./AdminPanelSidebar";
import AdminGuard from "../../components/core/admin-guard";
import { useTranslation } from "react-i18next";
import BackgroundCircle from "../../../assets/SVGComponents/BackgroundCircle";
import { 
  useAdminActivityMetrics,
  useAdminSchoolsAndGrades 
} from "../../../hooks/useAdminQuery";

/**
 * תבנית המבנה הראשית של דפי האדמין
 * כוללת את ה-Guard למניעת גישה לא מורשית
 * ואת בר הניווט העליון
 * טוענת נתוני פעילות מקיפים בכניסה לפאנל הניהול
 */
const AdminPanelLayout = observer(() => {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isRtl = i18n.language === "he";
  // TanStack Query hooks - automatically load data and sync to adminStore
  // Load all activity metrics once, filter client-side when school selection changes
  useAdminActivityMetrics();
  useAdminSchoolsAndGrades();

  return (
    <AdminGuard>
      <div className="admin-panel-layout__main-container">
        {/* רקע מעגלי כמו בשאר האפליקציה - רק במסכים גדולים */}
        {!isMobile && (
          <div className="admin-panel-layout__background-container">
            <BackgroundCircle width="100%" height={450} color="#bfd5f8" />
          </div>
        )}

        {/* בר ניווט עם תוכן ראשי */}
        <div className="admin-panel-layout__content-wrapper">
          <AdminPanelSidebar>
            <main 
              className={`admin-panel-layout__main-content ${
                isMobile ? 'admin-panel-layout__main-content--mobile' : 'admin-panel-layout__main-content--desktop'
              } ${
                isRtl ? 'admin-panel-layout__main-content--rtl' : 'admin-panel-layout__main-content--ltr'
              }`}
              tabIndex={0}
              aria-label="תוכן פאנל הניהול"
            >
              <Outlet />
            </main>
          </AdminPanelSidebar>
        </div>
      </div>
    </AdminGuard>
  );
});

export default AdminPanelLayout;
